/* BONEATO, tache 2 (lot P1 app, 2026-09-07) : etats « pressed ».
   Pose la classe .beo-tap sur l'element tapable le plus proche des le
   contact du doigt, et la retire des que l'utilisateur commence a
   scroller. Styles : assets/beo-touch-ux.css.

   Pourquoi pas :active tout seul ? Dans une webview iOS, :active se
   declenche aussi a l'amorce d'un scroll : toutes les cartes survolees
   par le pouce « clignotent ». On utilise donc les Pointer Events, ou
   le navigateur nous previent lui-meme qu'il prend la main pour
   scroller (pointercancel), + un seuil de mouvement en filet.

   Aucune detection d'app : ce comportement vaut aussi pour le site web
   mobile (contrainte « Option B »). */
(function () {
  "use strict";

  /* Elements tapables. closest() renvoie le plus INTERNE : un tap sur le
     « + » enfonce le bouton, pas la carte entiere. */
  var TAP_SEL = [
    ".beo-add-btn",
    ".button",
    ".beo-sidebar__link",
    ".beo-panel__item",
    ".beo-mood-tile",
    "[data-filter]",
    ".product-item"
  ].join(",");

  var MOVE_TOLERANCE = 10; // px avant de considerer que c'est un scroll
  var current = null;
  var startX = 0;
  var startY = 0;

  function clear() {
    if (!current) return;
    current.classList.remove("beo-tap");
    current = null;
  }

  function onDown(e) {
    // souris : bouton gauche seulement ; on ignore les taps multiples
    if (e.pointerType === "mouse" && e.button !== 0) return;
    clear();
    var el = e.target && e.target.closest ? e.target.closest(TAP_SEL) : null;
    if (!el) return;
    // un bouton deja desactive (ajout en cours, tache 1) ne s'enfonce pas
    if (el.disabled) return;
    current = el;
    startX = e.clientX;
    startY = e.clientY;
    el.classList.add("beo-tap");
  }

  function onMove(e) {
    if (!current) return;
    if (Math.abs(e.clientX - startX) > MOVE_TOLERANCE ||
        Math.abs(e.clientY - startY) > MOVE_TOLERANCE) {
      clear(); // le doigt glisse => c'est un scroll, pas un tap
    }
  }

  document.addEventListener("pointerdown", onDown, { passive: true });
  document.addEventListener("pointermove", onMove, { passive: true });
  // pointercancel = le navigateur a pris la main (scroll natif) : le
  // signal le plus fiable pour annuler l'etat pressed.
  document.addEventListener("pointercancel", clear, { passive: true });
  document.addEventListener("pointerup", clear, { passive: true });
  document.addEventListener("scroll", clear, { passive: true, capture: true });
  window.addEventListener("blur", clear);

  /* TODO (bloque cote MobiLoud, reponse attendue mer. 9/09) : loader
     page-to-page sous le header. C'est ICI qu'il se brancherait : ecouter
     le clic sur un lien interne et afficher une barre de progression sous
     le header jusqu'au unload. On attend leur reponse sur (a) le cache des
     assets statiques et (b) la methode de wiring cote shell avant
     d'implementer, pour ne pas poser deux loaders concurrents. */
})();
